import { External } from "@bcc-ui/ui-components";
import { t } from "i18next";
import React from "react";

import { NavigationSubMenuItem } from "./navigation-sub-menu-item/NavigationSubMenuItem";
import { useIsChildRouteEnabled } from "components/navigation/hooks/useIsChildRouteEnabled";
import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import { KNOWLEDGE_BASE_ROUTE, RouteDefinition } from "components/router/Routes";

import testIds from "testIds.json";

interface Props {
    mainRoute: RouteDefinition;
}

export const SupportSubmenu = (props: Props) => {
    const isRouteEnabled = useIsRouteEnabled();
    const { isChildRouteEnabled, isChildRouteAdvertised } = useIsChildRouteEnabled();

    if (!props.mainRoute || !isRouteEnabled(props.mainRoute)) {
        return null;
    }

    return (
        <>
            {props.mainRoute.childRoutes.map((childroute) => {
                if (!isChildRouteEnabled(childroute)) {
                    return null;
                }

                return (
                    <NavigationSubMenuItem
                        key={childroute.path}
                        to={childroute.path}
                        isAdvertised={isChildRouteAdvertised(childroute)}
                        rightSection={
                            childroute === KNOWLEDGE_BASE_ROUTE && (
                                <External size={20} color={"--app-subNavigationPanel-iconColor"} />
                            )
                        }
                        testId={childroute.testId}
                    >
                        {t(childroute.title)}
                    </NavigationSubMenuItem>
                );
            })}

            <NavigationSubMenuItem
                asExternalLink
                to={"https://support.blancco.com"}
                isAdvertised={false}
                rightSection={<External size={20} color={"--app-subNavigationPanel-iconColor"} />}
                testId={testIds.navigation.support.blanccoSupportLink}
            >
                {t("Common.blanccoSupport")}
            </NavigationSubMenuItem>
        </>
    );
};
